// Test hooks for the child components that need to be specifically addressed with a test id
export const TestHooks = {
	Link: 'link',
	StartOrderButton: 'start-order-button',
	ChangePropertyTypeButton: 'change-property-type-button',
	ChangePropertyAddressButton: 'change-property-address-button',
	MessageBar: 'message-bar',
	OpenKeyDatesDrawerButton: 'open-key-dates-drawer-button',
	EditPrioritySpan: 'edit-priority-span',
	EditPrioritySpan1: 'edit-priority-span-1',
	//	MyHookName: 'myHookIdentifier',
} as const;
/*
NOTE: The above hooks have been auto generated, all naming is a best guess approach.
Please review them, edit where necessary and delete this comment to indicate that the names are correct.
*/
